module.exports = __webpack_public_path__ + "img/AG.c0f6a70e.svg";